import { Link } from "react-router-dom";
import { Phone, ShieldCheck } from "lucide-react";

export default function SafetyCallout({ compact = false }) {
  return (
    <section className="lux-card relative overflow-hidden p-6 sm:p-10" data-testid="safety-callout">
      <div className="grid gap-8 md:grid-cols-[1.2fr_1fr] md:items-center">
        <div>
          <p className="lux-label">Safety first</p>
          <h2 className="mt-3 font-serif text-3xl leading-tight sm:text-4xl">Never pay a deposit to an account you can't verify.</h2>
          <p className="mt-4 max-w-lg text-sm leading-relaxed text-lux-muted">
            LUX never takes payments, so anyone asking you to pay "through LUX" is attempting fraud. If something suggests a person isn't independent, is under 18 or is under pressure, tell us - reports are anonymous.
          </p>
          {!compact && (
            <div className="mt-6 flex flex-wrap gap-3">
              <Link to="/safety" className="lux-btn lux-btn-secondary" data-testid="safety-callout-guide-link"><ShieldCheck className="h-4 w-4" /> Read the safety guide</Link>
              <Link to="/report" className="lux-btn lux-btn-ghost" data-testid="safety-callout-report-link">Report a concern</Link>
            </div>
          )}
        </div>
        <a href="tel:08000121700" className="group block rounded-[12px] border border-lux-border bg-lux-surface2 p-6 transition-colors hover:border-lux-silver/50" data-testid="safety-callout-helpline">
          <Phone className="h-5 w-5 text-lux-silver" aria-hidden="true" />
          <p className="mt-4 text-sm text-lux-muted">Modern Slavery &amp; Exploitation Helpline</p>
          <p className="mt-1 font-serif text-3xl text-lux-silverBright">08000 121 700</p>
          <p className="mt-2 text-xs text-lux-muted">Free, confidential, 24 hours. In an emergency call 999.</p>
        </a>
      </div>
    </section>
  );
}
